import { render, staticRenderFns } from "./PhienBanList.vue?vue&type=template&id=42a4783e&"
import script from "./PhienBanList.vue?vue&type=script&lang=js&"
export * from "./PhienBanList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports